"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (m) {
	return new Date(new Date().setMonth(new Date().getMonth() + m));
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/xMonthsAfter.js
// module id = 78
// module chunks = 0